import {
    ComponentConstructor,
    EVENT_MOUNTED,
    EVENT_UPDATED,
    LOOP,
    Options,
    ResponsiveOptions,
    SLIDE,
    Splide,
} from "@splidejs/splide";
import { Intersection } from "@splidejs/splide-extension-intersection";

import "./projects-slider.scss";

export class ProjectsSlider {
    #SELECTOR_SLIDER = '.projects-slider';

    #CLASS_NAME_SLIDER_SMALL = 'projects-slider--sm';
    #CLASS_NAME_SLIDER_AUTOPLAY = 'projects-slider--autoplay';

    #sliderRoot: HTMLElement;
    #slider: Splide;

    constructor() {
        this.#initElements();
        this.#initEvents();

        this.#slider.mount({
            ...this.#getExtensions(),
        });

        this.#tweakSlider();
    }

    #initElements(): void {
        this.#sliderRoot = document.querySelector(this.#SELECTOR_SLIDER);

        this.#slider = new Splide(this.#sliderRoot, {
            autoWidth: true,
            gap: 24,
            pagination: false,
            keyboard: true,
            slideFocus: true,
            mediaQuery: 'min',
            ...this.#getAutoplayOptions(),
            breakpoints: { ...this.#getBreakpoints() },
        });
    }

    #initEvents(): void {
        this.#slider.on(EVENT_MOUNTED, () => {
            this.#updateSliderType(this.#slider.options.perPage);
        });

        this.#slider.on(EVENT_UPDATED, (options) => {
            this.#updateSliderType(options.perPage);
        });
    }

    #updateSliderType(perPage: number): void {
        let type: string | undefined;

        if (this.#slider.is(LOOP) && this.#slider.length <= perPage) {
            type = SLIDE;
        } else if (!this.#slider.is(LOOP) && this.#slider.length >= perPage) {
            type = LOOP;
        }

        if (type) {
            this.#slider.options.type = type;
            this.#slider.refresh();
        }
    }

    #getExtensions() {
        const extensions: Record<string, ComponentConstructor> = {};

        if (this.#sliderRoot.classList.contains(this.#CLASS_NAME_SLIDER_AUTOPLAY)) {
            extensions['Intersection'] = Intersection;
        }

        return extensions;
    }

    #tweakSlider(): void {
    }

    #getBreakpoints(): Record<string | number, ResponsiveOptions> {
        if (this.#sliderRoot.classList.contains(this.#CLASS_NAME_SLIDER_SMALL)) {
            return {
                1: {
                    perPage: 1,
                    focus: 'center',
                    trimSpace: false,
                },
                576: {
                    focus: undefined,
                    trimSpace: true,
                },
                768: {
                    perPage: 2,
                },
                1200: {
                    perPage: 3,
                },
                1440: {
                    perPage: 4,
                },
            };
        }

        return {
            1: {
                perPage: 1,
                focus: 'center',
                trimSpace: false,
            },
            576: {
                focus: undefined,
                trimSpace: true,
            },
            992: {
                perPage: 2,
            },
            1400: {
                perPage: 3,
            },
        };
    }

    #getAutoplayOptions(): Partial<Options> {
        if (this.#sliderRoot.classList.contains(this.#CLASS_NAME_SLIDER_AUTOPLAY)) {
            return {
                type: LOOP,
                autoplay: 'pause',
                intersection: {
                    inView: {
                        autoplay: true,
                    },
                    outView: {
                        autoplay: false,
                    }
                },
            };
        }

        return {};
    }
}
